import { BsPeople } from "react-icons/bs";
import { FaMoneyCheckAlt, FaCreditCard, FaUserFriends } from "react-icons/fa";
import { RiExchangeDollarLine } from "react-icons/ri";
import { TbDatabaseDollar } from "react-icons/tb";

export const getSubscriptionsPageSideMenuItems = () => {
  return [
    {
      key: '1',
      icon: <RiExchangeDollarLine className="me-2" />,
      label: 'Upgrade Plan',
    },
    {
      key: '2',
      icon: <TbDatabaseDollar className="me-2" />,
      label: 'Billing',
    },
    {
      key: '3',
      icon: <BsPeople className="me-2" />,
      label: 'Invite a Friend',
    }
  ];
};